import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const jqRoutes: CustomRouteRecordRaw = {
  path: 'jq',
  name: 'jq',
  component: EmptyLayout,
  redirect: { name: 'workbench' },
  meta: {
    title: '职业兴趣测试',
    iconfont: 'icon-palette-fill',
    requiredPermission: 'jq',
  },
  children: [
    {
      path: 'jq-test-list',
      name: 'jqTestList',
      component: () => import('@/views/jq/jq-test-list.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'jq.test.list'
      },
    },
    {
      path: 'jq-test-report',
      name: 'jqTestReport',
      component: () => import('@/views/jq/jq-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'jq.test.report'
      },
    },
  ],
}
